export default __webpack_public_path__ + "static/media/16.db69f778.png";